import service from '@/store/services/general/reset-service';

const state = {
    list: {},
    reset: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, reset) => {
        state.reset = reset;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(reset => {
                commit('SET_RESOURCE', reset);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((reset) => {
                commit('SET_RESOURCE', reset);
            });
    },

};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    reset: state => state.reset,
    url: state => state.url,
};

const resets = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default resets;
